module.exports = __webpack_public_path__ + "img/CheckBoxold.d927e76a.svg";